import { fonts } from 'js/src/data/fonts/fonts-reducers';

export * from 'js/src/data/fonts/fonts-actions';
export * from 'js/src/data/fonts/fonts-selectors';
export * from 'js/src/data/fonts/fonts-operations';

export default fonts;
